import { SET_PAYLOAD } from "../actions/upsdk";

export default (state = {}, action = {}) => {
  switch (action.type) {
    case SET_PAYLOAD: {
      return action.data;
    }
    default:
      return state;
  }
};
